import Home from "./Components/Home.svelte"
import Assessor from "./Components/Assessor.svelte"
import Thermo from "./Components/Thermo/Thermo.svelte"

import Legal from './Components/Legal.svelte'
import Name from './Components/Questions/Name.svelte'
import Age from './Components/Questions/Age.svelte'
import Sex from './Components/Questions/Sex.svelte'
import Residence from './Components/Questions/Residence.svelte'
import Cellphone from './Components/Questions/Cellphone.svelte'
import Symptom from './Components/Questions/Symptom.svelte'
import Exposure from './Components/Questions/Exposure.svelte'
import travelCity from './Components/Questions/TravelCity.svelte'
import addQuestions from './Components/Questions/addQuestions.svelte'

import IdNumber from './Components/Questions/IdNumber.svelte'
import Department from './Components/Questions/Department.svelte'

import Result from './Components/Result.svelte'
import Qr from './Components/Qr.svelte'

const routes = [
    {
        name: '/',
        component: Home,
    },
    {
        name: '/assessor',
        component: Assessor,
    },
    {
        name: '/thermo',
        component: Thermo,
    },
    {
        name: '/legal',
        component: Legal,
    },
    {
        name: '/name',
        component: Name,
    },
    {
        name: '/age',
        component: Age,
    },
    {
        name: '/sex',
        component: Sex,
    },
    {
        name: '/residence',
        component: Residence,
    },
    {
        name: '/cellphone',
        component: Cellphone,
    },
    {
        name: '/symptom',
        component: Symptom,
    },
    {
        name: '/idNumber',
        component: IdNumber,
    },
    {
        name: '/department',
        component: Department,
    },
    {
        name: '/exposure',
        component: Exposure,
    },
    {
        name: '/travelCity',
        component: travelCity,
    },
    {
        name: '/addQuestions',
        component: addQuestions,
    },
    {
        name: '/result',
        component: Result,
    },
    {
        name: '/qr',
        component: Qr,
    },
];

export { routes }